export interface PaySafePaymentWithOrderCodesDTO {
    paySafePaymentID: string;
    paySafeMerchantRefNum: string;
    orderCodes: string;
    amount: number;
}
